const styles = `:host {
  display: flex;
  margin: 4px 16px;
}`; export default styles;